import { g as getNamedFormat, f as filterProps } from './utils-C5QdPtcV-A5kGtUmj.js';
import { a as IntlFormatError } from './error-CcshV7Gp-MfHpjqUW.js';
import { F as FormatError, E as ErrorCode } from '../../../../intl-messageformat/lib/src/error--j6_GWFu-BYuKgW-6.js';

var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function getFormatter(_a, getRelativeTimeFormat, options) {
  var locale = _a.locale,
    formats = _a.formats,
    onError = _a.onError;
  if (options === void 0) {
    options = {};
  }
  var format = options.format;
  var defaults = !!format && getNamedFormat(formats, 'relative', format, onError) || {};
  var filteredOptions = filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
  return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
  if (options === void 0) {
    options = {};
  }
  if (!unit) {
    unit = 'second';
  }
  var RelativeTimeFormat = Intl.RelativeTimeFormat;
  if (!RelativeTimeFormat) {
    config.onError(new FormatError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", ErrorCode.MISSING_INTL_API));
  }
  try {
    return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
  } catch (e) {
    config.onError(new IntlFormatError('Error formatting relative time.', config.locale, e));
  }
  return String(value);
}

export { formatRelativeTime as f };
//# sourceMappingURL=relativeTime-CVC0F98Q-bFdMYPtp.js.map
